var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ChangeDetectorRef, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { tap } from 'rxjs/operators';
import { chartConfig } from '../../../../app.constants';
import { UserService } from '../../../../services/user.service';
var ChannelReachComponent = /** @class */ (function () {
    function ChannelReachComponent(_userService, cd) {
        var _this = this;
        this._userService = _userService;
        this.hasNoData = true;
        this._channelReaches = [];
        this.showChannelSelector = false;
        this.channelSource = [];
        this.otherSelectedChannelIds = [];
        this._maxSelectedItemsCount = 3;
        this._selectedColor = _userService.chartColors[0];
        this._unselectedColor = chartConfig.unselectedColors[0];
        this.exceedMaxChannelSelection = new EventEmitter();
        this._placeholderChannelReachItems = [
            {
                channelName: 'Instagram',
                placeholderMode: true,
                chartData: [{
                        value: 0,
                        lineColor: 'rgba(113, 125, 141, 0.5)'
                    }],
                uniqueCode: "-111_false"
            },
            {
                channelName: 'Blogs',
                placeholderMode: true,
                chartData: [{
                        value: 0,
                        lineColor: 'rgba(113, 125, 141, 0.5)'
                    }],
                uniqueCode: "-222_false"
            },
            {
                channelName: 'Pinterest',
                placeholderMode: true,
                chartData: [{
                        value: 0,
                        lineColor: 'rgba(113, 125, 141, 0.5)'
                    }],
                uniqueCode: "-333_false"
            },
            {
                channelName: 'YouTube',
                placeholderMode: true,
                chartData: [{
                        value: 0,
                        lineColor: 'rgba(113, 125, 141, 0.5)'
                    }],
                uniqueCode: "-444_false"
            }
        ];
        this._initSubject = new Subject();
        this._channelReachesSubject = new Subject();
        this._selectedChannelIdSubject = new Subject();
        this._changeSubscription = combineLatest([
            this._channelReachesSubject,
            this._selectedChannelIdSubject,
            this._initSubject
        ]).pipe(tap(function () {
            _this.showChannelSelector = false;
            cd.detectChanges();
        })).subscribe({
            next: function (_a) {
                var channelReaches = _a[0], selectedChannelId = _a[1];
                if (_this.shouldShowPlaceholder(channelReaches, selectedChannelId)) {
                    _this.channelReachItems = _this._placeholderChannelReachItems;
                    _this.hasNoData = true;
                    return;
                }
                _this.hasNoData = false;
                _this.calculateChannelSelector(channelReaches, selectedChannelId);
                _this.drawChannelReaches(channelReaches, selectedChannelId, _this.otherSelectedChannelIds);
            }
        });
    }
    Object.defineProperty(ChannelReachComponent.prototype, "channelReaches", {
        set: function (value) {
            this._channelReaches = value;
            this._channelReachesSubject.next(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChannelReachComponent.prototype, "selectedChannelId", {
        set: function (value) {
            this._selectedChannelId = value;
            this._selectedChannelIdSubject.next(value);
        },
        enumerable: true,
        configurable: true
    });
    ChannelReachComponent.prototype.ngOnDestroy = function () {
        this._changeSubscription.unsubscribe();
    };
    ChannelReachComponent.prototype.ngOnInit = function () {
        this._initSubject.next(true);
    };
    ChannelReachComponent.prototype.shouldShowPlaceholder = function (channelReaches, selectedChannelId) {
        return (!Array.isArray(channelReaches) || channelReaches.length === 0)
            || (!channelReaches.find(function (c) { return c.channelId === selectedChannelId; }))
            || (this.forPayingUser && this._userService.isFreeUser() && !this._userService.isAdmin);
    };
    ChannelReachComponent.prototype.drawChannelReaches = function (channelReaches, selectedChannelId, otherIds) {
        var _this = this;
        var drawnChannelReaches = this.getDrawnChannelReaches(channelReaches, selectedChannelId, this.otherSelectedChannelIds);
        this.channelReachItems = drawnChannelReaches.map(function (item) {
            var isSelected = item.channelId === selectedChannelId;
            return __assign({}, item, { chartData: [{
                        value: item.reachPercentage,
                        lineColor: isSelected ? _this._selectedColor : _this._unselectedColor
                    }], reachChangePercentageDisplay: Math.abs(item.reachChangePercentage), isReachChangePositive: item.reachChangePercentage >= 0, uniqueCode: item.channelId + "_" + isSelected });
        });
    };
    ChannelReachComponent.prototype.getDrawnChannelReaches = function (channelReaches, selectedChannelId, otherIds) {
        var results = [];
        channelReaches.forEach(function (c) {
            var isDrawn = otherIds.indexOf(c.channelId) >= 0;
            if (isDrawn) {
                results.push(c);
            }
        });
        var selectedChannelReach = channelReaches.find(function (x) { return x.channelId === selectedChannelId; });
        if (selectedChannelReach) {
            results.unshift(selectedChannelReach);
        }
        return results;
    };
    ChannelReachComponent.prototype.calculateChannelSelector = function (channelReaches, selectedChannelId) {
        this.showChannelSelector = channelReaches.length > 1;
        if (!this.showChannelSelector) {
            this.channelSource = [];
            this.otherSelectedChannelIds = [];
            return;
        }
        var others = channelReaches.filter(function (x) { return x.channelId !== selectedChannelId; });
        this.channelSource = others.map(function (x) {
            return {
                channelId: x.channelId,
                channelName: x.channelName,
                platformName: x.platformName,
            };
        });
        var sortedTop = others.sort(function (a, b) { return b.reach - a.reach; }).slice(0, this._maxSelectedItemsCount);
        this.otherSelectedChannelIds = sortedTop.map(function (x) { return x.channelId; });
    };
    ChannelReachComponent.prototype.onSelectionChange = function (selectedChannels) {
        if (selectedChannels.length > this._maxSelectedItemsCount) {
            this.otherSelectedChannelIds = this.otherSelectedChannelIds.slice();
            this.exceedMaxChannelSelection.emit(null);
            return;
        }
        this.otherSelectedChannelIds = selectedChannels.map(function (x) { return x.channelId; });
        this.drawChannelReaches(this._channelReaches, this._selectedChannelId, this.otherSelectedChannelIds);
    };
    ChannelReachComponent.prototype.channelReachItemTrackBy = function (index, item) {
        return item.uniqueCode;
    };
    return ChannelReachComponent;
}());
export { ChannelReachComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/channel-reach/channel-reach.component.ts.pre-build-optimizer.js